import axios from "axios";
import { apiPath, apiPath1 } from "../../constants/config";
let token = localStorage.getItem("accessToken");
let config = {
  headers: {
    Authorization: "Bearer " + token
  }
};
const state = {
  isLoadCommandes: false,
  isLoadRestau20: false,
  errorRestau2: "",
  commandes: [],
  commandesSearchResult: null,
  conversationsRestau: null,
  pages: 1
};

const getters = {
  isLoadCommandes: state => state.isLoadCommandes,
  isLoadRestau20: state => state.isLoadRestau20,
  errorRestau2: state => state.errorRestau2,
  commandes: state => state.commandes,
  pages: state => state.pages,
};

const mutations = {
  getCommandesSuccess(state, payload) {
    state.isLoadCommandes = true;
    state.commandes = payload.commandes;
  },
  setPages(state, payload) {
    state.pages = payload.pages;
  },
  changeCommandeSuccess(state, payload) {
    // console.log({payload});
    // console.log("FROMMUATETTAGSUCCES");
    state.isLoadCommandes = true;
    
  },
  editCommandeSuccess(state, payload) {
    console.log("FROM MUTATE");
    console.log(payload);
    state.isLoadCommandes = true;
    let commandes = state.commandes;

    let newCommandes = [];
    commandes.map((commande, index) => {
      if (commande._id == payload.data._id) {
        newCommandes.push({ ...payload.data });
      } else {
        newCommandes.push({ ...commande });
      }
    });
    state.commandes = [...newCommandes];
  },
  deleteCommandeSuccess(state, payload) {
    state.isLoadCommandes = true;
    let commandes = state.commandes;

    let newCommandes = [];
    commandes.map((commande, index) => {
      if (commande._id != payload.data._id) {
        newCommandes.push({ ...commande });
      }
    });
    state.commandes = [...newCommandes];
  },
  addCMDSuccess(state, payload) {
    state.isLoadCommandes = true;

  },
  getCommandesError(state, error) {
    state.isLoadCommandes = false;
    state.errorRestau2 = error;
  },
  addCommandeError(state, error) {
    state.isLoadCommandes = false;
    state.errorRestau2 = error;
  }
};

const actions = {
  getCommandes({ commit }, payload) {
    // token = localStorage.getItem("accessToken")
    let { page, perPage } = payload;
    axios
      .get(
        `${apiPath}/commandes/${payload.restau}?page=${page}&perPage=${perPage}`
      )
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getCommandesSuccess", {
            commandes: res.data
          });
          commit("setPages", {
            commandes: res.pages
          });
        } else {
          commit("getCommandesError", "error:getCommandes");
        }
      });
  },
  ChangeCommandeState({ commit }, payload) {
    return axios
      .post(`${apiPath}/commandes/state`, payload, config)
      .then(r => r.data)
      .then(res => {
       
        return res;
      });
  },
  editCommande({ commit }, payload) {
    console.log("FROM EDIT TAG AXIOS");
    console.log(payload);
    return axios
      .post(`${apiPath}/commandes/${payload.id}`, payload.formdata, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("editCommandeSuccess", res);
        } else {
          commit("addCommandeError", "error:addCommande");
        }
        return res;
      });
  },
  // SyncRestau({ commit }, payload,config) {
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/definition`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/price`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });

  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/master`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });

  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/class`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/family/group`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  // },

  deleteCommande({ commit }, payload) {
    return axios
      .delete(`${apiPath}/commandes/${payload._id}`, config)
      .then(r => r.data)
      .then(res => {
        // if (res.ok) {
        //   commit("deletePosSuccess", payload);
        // } else {
        //   commit("addPosError", "error:addPos");
        // }
        return payload;
      });
  },
  createClient({ commit }, payload) {
    return axios
      .post(`${apiPath}/create/client`, payload)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("addCMDSuccess", res);
        } else {
        }
        return res;
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
